// 收银台
export default [
  {
    path: "/cashier",
    meta: { title: "收银台" },
    component: () => import("../views/cashier/index"),
    children: [
      {
        path: "/cashier/serviceList",
        name: "cashierServiceList",
        meta: { title: "服务项目收银台", isMenu: true },
        component: () => import("../views/cashier/serviceList"),
      },
      {
        path: "/cashier/detail/addSericeOrder",
        name: "addSericeOrder",
        meta: { title: "开单" },
        component: () => import("../views/cashier/detail/addSericeOrder"),
      },
      {
        path: "/cashier/productList",
        name: "cashierProductList",
        meta: { title: "商品收银台", isMenu: true },
        component: () => import("../views/cashier/productList"),
      },
      {
        path: "/cashier/detail/addProductOrder",
        name: "addProductOrder",
        meta: { title: "开单" },
        component: () => import("../views/cashier/detail/addProductOrder"),
      },
    ],
  },
]
